import { useQueryFolder } from './useQueryFolder.js';
import { useQueryResourceRootSpaceSystemList } from '../../spaces/queries/useQueryResourceRootSpaceSystemList.js';
import React__default from 'react';

const useQuerySpaceOrFolderById = (id) => {
  const { isLoading: spacesIsLoading, spaceRoots } = useQueryResourceRootSpaceSystemList(void 0, {
    includeInbox: true
  });
  const foundSpace = spaceRoots?.find((space) => space.id === id);
  const { folder } = useQueryFolder({
    resourceId: id
  }, {
    /**
    * disabled when spaces are not loaded yet
    * then check if the provided id is space. If true,we don't need to fetch the folder
    */
    enabled: !spacesIsLoading && !foundSpace
  });
  return React__default.useMemo(() => {
    if (foundSpace) {
      return {
        type: "space",
        data: foundSpace,
        id: foundSpace.id,
        name: foundSpace.folder.name || "Untitled space"
      };
    }
    if (folder) {
      return {
        type: "folder",
        data: folder,
        id: folder.id,
        name: folder.name || "Untitled folder"
      };
    }
    return null;
  }, [
    folder,
    foundSpace
  ]);
};

export { useQuerySpaceOrFolderById };
//# sourceMappingURL=useQuerySpaceOrFolderById.js.map
